export const CALLOUT_CONTENT_FRAGMENT = `
  calloutVariant
  headerText 
  bodyText
  outerTopContent
  outerBottomContent
`;
